import classNames from 'clsx';
import type { FC } from 'react';

import type { StakeAndReturnProps } from '../../StakeAndReturn';

import styles from './StakeTitle.scss';

interface Props {
  title: string;
  variant: StakeAndReturnProps['variant'];
}

export const StakeTitle: FC<Props> = ({ title, variant }) => (
  <span className={classNames(styles.title, styles[variant])}>{title}</span>
);
